document.addEventListener('DOMContentLoaded', function() {
  const jobs = [
    { "job": "Artist", "image": "/cdn/shop/t/3/assets/Artist.png" },
    { "job": "Astronaut", "image": "/cdn/shop/t/3/assets/Astronaut.png" },
    { "job": "Chef", "image": "/cdn/shop/t/3/assets/Chef.png" },
    { "job": "Doctor", "image": "/cdn/shop/t/3/assets/Doctor.png" },
    { "job": "Engineer", "image": "/cdn/shop/t/3/assets/Engineer.png" },
    { "job": "Firefighter", "image": "/cdn/shop/t/3/assets/Firefighter.png" },
    { "job": "Pilot", "image": "/cdn/shop/t/3/assets/Pilot.png" },
    { "job": "Policeman", "image": "/cdn/shop/t/3/assets/Policeman.png" },
    { "job": "Scientist", "image": "/cdn/shop/t/3/assets/Scientist.png" },
    { "job": "Soldier", "image": "/cdn/shop/t/3/assets/Soldier.png" },
    { "job": "Teacher", "image": "/cdn/shop/t/3/assets/Teacher.png" }
  ];
  let index = 0;
  const jobTitle = document.querySelector('.kid-jobs-section__big-text-artist');
  const jobImage = document.querySelector('.kid-jobs-section__image');
  if (!jobTitle || !jobImage) return;

  function typeWriterEffect(text, callback) {
    jobTitle.textContent = '';
    let i = 0;
    function type() {
      if (i < text.length) {
        jobTitle.textContent += text.charAt(i);
        i++;
        setTimeout(type, 60);
      } else if (callback) {
        callback();
      }
    }
    type();
  }

  function showNextJob() {
    index = (index + 1) % jobs.length;
    typeWriterEffect(jobs[index].job, function() {
      jobImage.src = jobs[index].image;
      setTimeout(showNextJob, 2000);
    });
  }

  // Start with the first job
  typeWriterEffect(jobs[index].job, function() {
    jobImage.src = jobs[index].image;
    setTimeout(showNextJob, 2000);
  });
}); 

